var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.667 0.666748C33.265 0.666748 42.667 10.0688 42.667 21.6667C42.667 26.6246 40.9489 31.1811 38.0757 34.7735L46.6502 43.3502C47.5615 44.2614 47.5615 45.7388 46.6502 46.65C45.8091 47.4911 44.4856 47.5558 43.5702 46.8441L43.3504 46.65L34.7737 38.0755C31.1814 40.9487 26.6248 42.6668 21.667 42.6668C10.069 42.6668 0.666992 33.2647 0.666992 21.6667C0.666992 10.0688 10.069 0.666748 21.667 0.666748ZM21.667 5.33342C12.6463 5.33342 5.33366 12.6461 5.33366 21.6667C5.33366 30.6874 12.6463 38.0001 21.667 38.0001C30.6876 38.0001 38.0003 30.6874 38.0003 21.6667C38.0003 12.6461 30.6876 5.33342 21.667 5.33342Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.44ca172f.svg";
export { ForwardRef as ReactComponent };